import _ from 'underscore'
import {Component} from 'preact'

type cb = (x: number, y: number) => void

interface Props {
  onMove: cb
}

interface State {
  x: number,
  y: number
}

export default class Tracker extends Component<Props, State> {
  constructor () {
    super()
    this.listener = _.throttle(this.listener.bind(this), 30)
  }

  componentDidMount () {
    document.body.addEventListener('mousemove', this.listener)
  }

  componentWillUnmount () {
    document.body.removeEventListener('mousemove', this.listener)
  }

  listener (e: MouseEvent) {
    this.props.onMove(e.clientX, e.clientY)
  }

  render () {
    return null
  }
}
